import React from "react";
function Answerticket()

{
    return(
        <>
        <h2> Answerticket</h2>
        </>
    )
}
export default Answerticket;